export const listFromMultiline = (value: string | undefined): string[] =>
  (value ?? '')
    .split(/\r?\n|,/)
    .map((item) => item.trim())
    .filter(Boolean)

export const multilineFromList = (
  values: readonly string[] | undefined
): string => (values ?? []).join('\n')

// Accepts http(s):// URLs, mobile custom schemes (com.example.app://...),
// urn: URIs, and other RFC-3986-ish absolute references. We intentionally
// stay permissive — the backend remains the authoritative validator.
const URI_PATTERN = /^[a-zA-Z][a-zA-Z0-9+.-]*:(?:\/\/)?[^\s]+$/

export const isLikelyValidRedirectUri = (uri: string): boolean =>
  URI_PATTERN.test(uri.trim())

export const validateUriList = (
  value: string | undefined
): { ok: true } | { ok: false; invalid: string[] } => {
  const lines = listFromMultiline(value)
  const invalid = lines.filter((line) => !isLikelyValidRedirectUri(line))

  return invalid.length ? { ok: false, invalid } : { ok: true }
}

// CORS origins are scheme + host + optional port — never a path, query, or
// fragment. Browsers reject the preflight if Access-Control-Allow-Origin
// returns anything richer than that, so we filter it on the form too.
export const isLikelyValidOrigin = (raw: string): boolean => {
  const value = raw.trim()
  if (!value) return false
  try {
    const url = new URL(value)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false
    if (url.pathname && url.pathname !== '/') return false
    if (url.search || url.hash) return false
    return true
  } catch {
    return false
  }
}

export const validateOriginList = (
  value: string | undefined
): { ok: true } | { ok: false; invalid: string[] } => {
  const lines = listFromMultiline(value)
  const invalid = lines.filter((line) => !isLikelyValidOrigin(line))

  return invalid.length ? { ok: false, invalid } : { ok: true }
}
